import gql from 'graphql-tag'

export const gqlInvoices = gql`
  query historicoFaturas($idConta: String!, $page: Int) {
    historicoFaturas(idConta: $idConta, pagina: $page) {
      faturas {
        numero
        valor
        dataVencimento
        numero
        status
        formaPagamento
        mes
        nsu
        qtdTransacoes
        exibirTransacoes
        linkBoleto
      }
      paginacao {
        anterior
        atual
        proxima
        total
      }
    }
  }
`

export const gqlInvoice = gql`
  query detalheFatura($idConta: String!, $faturaId: Int!, $qtdTransacoes: Int!) {
    detalheFaturaPj(idConta: $idConta, numeroFatura: $faturaId, qtdTransacoes: $qtdTransacoes) {
      servicosVeloe {
        tipoTransacao
        quantidade
        total
      }
      consumos {
        tipoTransacao
        quantidade
        total
      }
      transacoes {
        placa
        condutor
        total
        transacoesAgrupadas {
          tipoTransacao
          total
          transacaoes {
            data
            hora
            categoria
            horaEntrada
            horaSaida
            estabelecimento
            valor
            endereco
            permanencia
          }
        }
      }
      formaPagamento
      total
      linkNFE
      numeroNF
      dataEmissaoNF
      error
      totalBeneficios
      subTotal
      dataVencimento
      exibirTransacoes
      linkFaturaPDF
      linkFaturaCSV
      linkBoleto
    }
  }
`

export const gqlDownloadFaturaPdf = gql`
  query downloadFaturaPdf($idConta: String!, $numeroFatura: Int!) {
    downloadFaturaPdf(idConta: $idConta, numeroFatura: $numeroFatura) {
      result
    }
  }
`

export const gqlDownloadFaturaCsv = gql`
  query downloadFaturaCsv($idConta: String!, $numeroFatura: Int!) {
    downloadFatura(idConta: $idConta, numeroFatura: $numeroFatura) {
      result
    }
  }
`

export const gqlDownloadBoleto = gql`
  query downloadBoleto($idConta: String!, $nsu: Int!) {
    downloadBoleto(idConta: $idConta, nsu: $nsu) {
      result
    }
  }
`

export const gqlSolicitarBoleto = gql`
  mutation solicitarBoleto($idConta: String, $nsu: String) {
    solicitarBoleto(idConta: $idConta, nsu: $nsu) {
      codigo
      mensagem
    }
  }
`



// WEBPACK FOOTER //
// ./src/alelo-logic/services/queries/invoices.js